import AuthService from './authService';

class TokenRefreshService {
  constructor() {
    this.refreshInterval = null;
    this.refreshTime = 5 * 60 * 1000; // 5 minutes before expiry
  }

  // Start periodic token refresh
  startTokenRefresh() {
    if (this.refreshInterval) {
      this.stopTokenRefresh();
    }

    this.refreshInterval = setInterval(async () => {
      try {
        const token = AuthService.getAccessToken();
        if (token && AuthService.isTokenExpired(token)) {
          console.log('Token expired, attempting refresh...');
          await AuthService.refreshToken();
        }
      } catch (error) {
        console.error('Periodic token refresh failed:', error);
        this.stopTokenRefresh();
      }
    }, this.refreshTime);
  }

  // Stop periodic token refresh
  stopTokenRefresh() {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
      this.refreshInterval = null;
    }
  }

  // Check if token needs refresh and refresh if needed
  async checkAndRefreshToken() {
    try {
      const token = AuthService.getAccessToken();
      if (token && AuthService.isTokenExpired(token)) {
        console.log('Token needs refresh, refreshing...');
        await AuthService.refreshToken();
        return true;
      }
      return false;
    } catch (error) {
      console.error('Token refresh check failed:', error);
      throw error;
    }
  }

  // Set custom refresh time (in milliseconds)
  setRefreshTime(time) {
    this.refreshTime = time;
  }
}

export default new TokenRefreshService(); 